var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/chevronUp.961b008d.png","uri@2x": __webpack_public_path__ + "static/media/chevronUp.aa1d22a6.png","uri@3x": __webpack_public_path__ + "static/media/chevronUp.3b3fcd13.png",
    width: 16,
    height: 16
});